module.exports = __webpack_public_path__ + "img/Twitter Icon - white.af11f596.svg";